import * as classes from './Link.module.scss';
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Link } from 'gatsby-plugin-react-i18next';
import clsx from 'clsx';
import { Button } from '../Button';

export const linkStyles = {
    className: classes.link,
};

/**
 * Text starting with [ and ending with ] will be read as button
 */
const isMarkdownButton = (content: React.ReactNode | undefined): boolean => {
    return typeof content === 'string' && content.startsWith('[') && content.endsWith(']');
};

/**
 * Tries to create an internal Gatsby Link or renders a normal link for absolute URLs.
 * If the Text is recognized as button, it will render a Button links instead.
 * @see isMarkdownButton
 */
export const TargetAwareLink = React.forwardRef<HTMLAnchorElement, React.HTMLProps<HTMLAnchorElement>>((props, ref) => {
    const { href, className, ...rest } = props;

    if (isMarkdownButton(props.children)) {
        return <Button as="a" href={href} size="small">{(props.children as string).slice(1, -1)}</Button>;
    }

    const mergedClass = clsx(className, linkStyles.className);

    if (!href) {
        return <a {...rest} className={mergedClass} />;
    }

    const isRelative = href.startsWith('/');
    const isLocalized = isRelative && /^\/[a-z]{2}(-[A-Z])?\//.test(href);
    const isFile = /\.[a-z]{2,}(\?.+)?$/.test(href);

    if (!isFile && isRelative && !isLocalized) {
        return <Link to={href} {...rest} className={mergedClass} ref={ref} />;
    }

    if (!isFile && isRelative) {
        // @ts-ignore
        return <GatsbyLink to={href} {...rest} className={mergedClass} ref={ref} />;
    }

    return <a rel="noopener nofollow" {...rest} href={href} className={mergedClass} ref={ref} />;
});
